/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivitySearchPageRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {ActivitySearchResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const searchActivity = (request:ActivitySearchPageRequest, options?: CashRequestOptions) => post<ActivitySearchPageRequest, ActivitySearchResponse>("/2.0/cash/search-activity", request, {...options, rejectOnError: true })